import { Template } from '@/interfaces/template';
import { EntityResource } from './entity.resource';
import { FilterArgs, FilterVariables } from './queryVariables/filters/filters';

/**
 * Resource wzorów procedury
 *
 * @export
 * @class TemplateResource
 * @extends {EntityResource<Template>}
 */
export class TemplateResource extends EntityResource<Template> {
  public getFields = {
    id: true,
    name: true,
    statuses: {
      name: true,
      type: true
    },
    data: true
  };

  public listFields = { id: true, name: true };

  protected listVariables = FilterVariables;
  protected listArgs = FilterArgs;

  constructor() {
    super({
      entityName: 'template'
    });
  }
}

export const templateResource = new TemplateResource();
